"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootReducer = void 0;
var redux_1 = require("redux");
var connected_react_router_1 = require("connected-react-router");
var reducer_1 = __importDefault(require("./app/reducer"));
var reducer_2 = __importDefault(require("./restaurant/reducer"));
var reducer_3 = __importDefault(require("./cart/reducer"));
var reducer_4 = __importDefault(require("./auth/reducer"));
var reducer_5 = __importDefault(require("./payment/reducer"));
var reducer_6 = __importDefault(require("./orders/reducer"));
var reducer_7 = __importDefault(require("./product/reducer"));
var rootReducer = function (history) { return (0, redux_1.combineReducers)({
    router: (0, connected_react_router_1.connectRouter)(history),
    app: reducer_1.default,
    restaurant: reducer_2.default,
    cart: reducer_3.default,
    auth: reducer_4.default,
    payment: reducer_5.default,
    orders: reducer_6.default,
    product: reducer_7.default
}); };
exports.rootReducer = rootReducer;
